import { render, staticRenderFns } from "./DailyBidsCount.vue?vue&type=template&id=eb53a460&"
import script from "./DailyBidsCount.vue?vue&type=script&lang=js&"
export * from "./DailyBidsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports